import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export type XDPRedesignPhase1ContextType = {
  /** @deprecated This experiment has been replaced with individual flags */
  enableXDPRedesignPhase1: boolean;
  enableXDPRedesignKIM: boolean;
  enableXDPRedesignHero: boolean;
  enableXDPRedesignDescriptionRework: boolean;
  enableXDPRedesignClickableSkills: boolean;
  disableXDPThinBanner: boolean;
};

export const XDPRedesignPhase1Context = createContext<XDPRedesignPhase1ContextType>({
  /** @deprecated This experiment has been replaced with individual flags */
  enableXDPRedesignPhase1: false,
  // These four epics are part of the phase 1.1 experiment
  enableXDPRedesignKIM: false,
  enableXDPRedesignHero: false,
  enableXDPRedesignDescriptionRework: false,
  enableXDPRedesignClickableSkills: false,
  // These epic is used to disable content for the control, it is not compatible with the new phase 1 experiment
  disableXDPThinBanner: false,
});

function XDPRedesignPhase1Provider({ children }: React.PropsWithChildren) {
  const [enableXDPRedesignPhase1] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignPhase1'));
  const [enableXDPRedesignKIM] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignKIM'));
  const [enableXDPRedesignHero] = useState(GrowthDiscoveryEpicClient.get('enableXDPRedesignHero'));
  const [disableXDPThinBanner] = useState(GrowthDiscoveryEpicClient.get('disableXDPThinBanner'));
  const [enableXDPRedesignDescriptionRework] = useState(
    GrowthDiscoveryEpicClient.get('enableXDPRedesignDescriptionRework')
  );
  const [enableXDPRedesignClickableSkills] = useState(
    GrowthDiscoveryEpicClient.get('enableXDPRedesignClickableSkills')
  );

  return (
    <XDPRedesignPhase1Context.Provider
      value={{
        enableXDPRedesignPhase1,
        enableXDPRedesignKIM,
        enableXDPRedesignHero,
        enableXDPRedesignDescriptionRework,
        enableXDPRedesignClickableSkills,
        disableXDPThinBanner,
      }}
    >
      {children}
    </XDPRedesignPhase1Context.Provider>
  );
}

export const useXDPRedesignPhase1Data = () => {
  return (
    useContext(XDPRedesignPhase1Context) || {
      enableXDPRedesignPhase1: false,
      enableXDPRedesignKIM: false,
      enableXDPRedesignHero: false,
      enableXDPRedesignDescriptionRework: false,
      enableXDPRedesignClickableSkills: false,
      disableXDPThinBanner: false,
    }
  );
};

export default XDPRedesignPhase1Provider;
